(function () {
    'use strict';

    angular
        .module('app')
        .controller('BuscadorControllerComponent', Controller);

    /* @ngInject */
    function Controller($stateParams, Idioma, Biblioteca) {
        var vm = this;

        vm.search = function () {
            vm.onBuscar(false);
        };

        vm.clear = function () {
            vm.onClear();
        };

        // Servicios para los tesauros
        vm.idiomaService = Idioma;
        vm.bibliotecaService = Biblioteca;
    }

})();
